import { deleteMedia } from 'containers/QuestionnairePage/model';
import { get } from 'lodash';
import {
  call,
  put,
  select,
  takeEvery,
  all,
  throttle,
} from 'redux-saga/effects';
import {
  makeSelectUserDetails,
  makeSelectUserEmail,
} from 'containers/User/selectors';
import { makeSelectSurveyDetails } from 'containers/Survey/selectors';
import {
  triggerAutosaveRevision,
  reportToSegment,
  trackEvent,
} from 'containers/App/actions';
import { makeSelectCurrentRoute } from 'containers/App/selectors';
import { isInAdvancedLogic } from 'containers/SurveysAccountsLayout/utils/index';
import { triggerAutosaveRevision as triggerAutosaveRevisionModel } from 'components/QuestionnaireRevisions/model';
import { httpRequest } from 'utils/http';
import openNotification from 'utils/openNotification';
import sagaListen from 'utils/sagaListen';
import {
  GENERIC_ERROR,
  DELETE_MEDIA,
  TRIGGER_AUTOSAVE_REVISION,
  TRACK_ANALYTICS_EVENT,
  SHOW_GENERAL_NOTIFICATION,
  ANALYTICS_EVENTS_ENUM,
  TRIGGER_AUTOSAVE_REVISION_INTERVAL,
  isDevelopment,
} from './constants';

export function* reportToSegmentSaga() {
  // Select userDetails from store
  const userDetails = yield select(makeSelectUserDetails);
  yield put(reportToSegment(userDetails));
}

export function* trackAnalyticsEventSaga({ name }) {
  // Select userDetails from store
  const userDetails = yield select(makeSelectUserDetails);
  const surveyDetails = yield select(makeSelectSurveyDetails);
  const { email, isAdmin } = userDetails;

  if (isAdmin || isDevelopment) {
    return;
  }

  let eventName = name;
  const payload = {
    s_id: surveyDetails.id,
    email,
    surveyStatus: surveyDetails.statusName,
  };

  switch (name) {
    case ANALYTICS_EVENTS_ENUM.PREVIEW_NEW_TAB: {
      const route = yield select(makeSelectCurrentRoute);
      const url = get(route, 'pathname', '');
      if (isInAdvancedLogic(url)) {
        eventName = ANALYTICS_EVENTS_ENUM.PREVIEW_PANE_ADL_TAB;
      }
      break;
    }
    default: {
      break;
    }
  }

  yield put(trackEvent(eventName, payload));
}

export function* triggerAutosaveRevisionSaga({ surveyId }) {
  try {
    // media support aligns with revision support.
    // If that changes, then we need to check whether to call triggerAutosaveRevision or not.
    yield call(httpRequest, triggerAutosaveRevisionModel, {
      excludedStatuses: [400],
      params: {
        surveyId,
      },
    });
  } catch (ex) {
    // Do nothing
  }
}

export function* showGeneralNotificationSaga({ payload }) {
  openNotification(payload);
}

export function* deleteMediaSaga({ surveyId, refId, mediaType, side }) {
  yield put(triggerAutosaveRevision(surveyId));
  const userEmail = yield select(makeSelectUserEmail);

  try {
    yield call(httpRequest, deleteMedia, {
      excludedStatuses: [400, 403, 404],
      params: {
        surveyId,
        refId,
        mediaType,
        side,
      },
    });
  } catch (error) {
    yield put(
      reportToSegment({
        surveyId,
        refId,
        mediaType,
        side,
        message: new Error(error),
        email: userEmail,
      }),
    );
  }
}

export default function* defaultSaga() {
  yield all([
    call(sagaListen, GENERIC_ERROR, reportToSegmentSaga),
    takeEvery(DELETE_MEDIA, deleteMediaSaga),
    takeEvery(TRACK_ANALYTICS_EVENT, trackAnalyticsEventSaga),
    takeEvery(SHOW_GENERAL_NOTIFICATION, showGeneralNotificationSaga),
    throttle(
      TRIGGER_AUTOSAVE_REVISION_INTERVAL,
      TRIGGER_AUTOSAVE_REVISION,
      triggerAutosaveRevisionSaga,
    ),
  ]);
}
